const HealthJourneyTestIds = {
  clientJourneyHeader: 'hj-client-journey-header',
  weightLossMedicationLabel: 'hj-weight-loss-medication-label',
  weightLossMedicationValue: 'hj-weight-loss-medication-value',
  weightLossMedicationInfoIcon: 'hj-weight-loss-medication-info-icon',
  clientPlan: 'hj-client-plan-label',
  clientPlanDescription: 'hj-client-plan-description',
  clientProgramStartDateLabel: 'hj-client-program-start-date-label',
  clientProgramStartDateValue: 'hj-client-program-start-date-value',
  clientWhyLabel: 'hj-client-why-label',
  clientWhyValue: 'hj-client-why-value',
};

export default HealthJourneyTestIds;
